import type React from 'react'
import type { IconProps } from './types'

const QuestionTemplateIcon: React.FC<IconProps> = ({ size = 20, className = 'text-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M5.55 19L2 15.45L3.4 14.05L5.525 16.175L9.775 11.925L11.175 13.35L5.55 19ZM5.55 11L2 7.44999L3.4 6.04999L5.525 8.17499L9.775 3.92499L11.175 5.34999L5.55 11ZM13 17V15H22V17H13ZM13 8.99999V6.99999H22V8.99999H13Z' />
	</svg>
)

export default QuestionTemplateIcon
